<template>
  <div class="my-4">
    <div class="div-container">
      <div class="row align-items-center">
        <div class="col-12 col-md">
          <div class="d-flex">
            <div class="label">Tipo de Programa:</div>
            <div>{{ item.programType.name }}</div>
          </div>
        </div>
        <div v-if="item.program" class="col-12 col-md">
          <div class="d-flex">
            <div class="label">Programa:</div>
            <div>{{ item.program.name }}</div>
          </div>
        </div>
        <div class="col-12 col-md">
          <div class="d-flex">
            <div class="label">Presupuesto:</div>
            <div>{{ item.projectedFund | price }}</div>
          </div>
        </div>
        <div v-if="!isReadOnly" class="col-auto text-right">
          <i class="fal fa-times-circle text-danger" @click="remove(item)" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md">
          <div class="d-flex">
            <div class="label">Número de Cifra:</div>
            <div>{{ fullNumber }}</div>
          </div>
        </div>
        <div class="col-12 col-md">
          <div class="d-flex">
            <div class="label">PRIFAS:</div>
            <div>{{ item.prifas }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';

export default {
  name: 'BudgetSources',
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    fullNumber() {
      const safe = (v) => (v !== null && v !== undefined ? String(v) : ''); // reemplazo de ISNULL

      // Fund-Agency-CostCenter-Program(PAS)-BudgetYear-Approp-Account-ProjectID-InterFund-Future1-Future2
      return [
        safe(this.item.fund),
        safe(this.item.dept),
        safe(this.item.costCenter),
        safe(this.item.manualProgram),
        safe(this.item.budRef),
        safe(this.item.class),
        safe(this.item.account),
        safe(this.item.project),
        safe(this.item.interFund),
        safe(this.item.future1),
        safe(this.item.future2),
      ]
        .join('-')
        .replace(/-+$/, ''); // sin guiones al final si no hay Future
    },
  },
  methods: {
    remove() {
      this.$emit('remove', this.item);
    },
  },
};
</script>
<style scoped>
.label {
  font-size: 16px !important;
  color: #727272 !important;
  margin-right: 5px;
}

.div-container {
  padding: 20px;
  background: white;
  border-radius: 4px;
  outline: 1px solid #e2e2e2;
  outline-offset: -1px;
}

.d-flex {
  align-items: center;
  min-height: 100%;
}

.row {
  align-items: center;
}
</style>
